import { Grid, IconButton, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";

const useStyle = makeStyles((theme) => ({
  scrollOnTop: {
    position: "fixed",
    height: theme.spacing(5.5),
    width: theme.spacing(5.5),
    right: theme.spacing(7),
    bottom: `${window.innerHeight / 10}px`,
    boxShadow: "0 2px 4px 0 rgba(90,90,90,0.1)",
    backgroundColor: "#576bea",
    "&:hover": {
      backgroundColor: "#576bea",
    },
  },
}));

export default function ScrollToTop() {
  const classes = useStyle();
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <div className="scroll-to-top">
      {isVisible && (
        <Grid xs={12} item container justify="flex-end" alignItems="center">
          <IconButton onClick={scrollToTop} className={classes.scrollOnTop}>
            <img src="/whiteArrow.svg" alt="Go To Top" />
          </IconButton>
        </Grid>
      )}
    </div>
  );
}
